﻿document.addEventListener("DOMContentLoaded", function () {
    const shrink_btn = document.querySelector(".shrink-btn");
    if (shrink_btn) {
        shrink_btn.addEventListener("click", () => {
            document.body.classList.toggle("shrink");
            shrink_btn.classList.add("hovered");
        });
    }
});
document.addEventListener("DOMContentLoaded", function () {
    const profileButton = document.getElementById("profile-button");
    const profileBox = document.getElementById("profile-box");
    if (profileButton && profileBox) {
        profileButton.addEventListener("click", function () {
            profileBox.classList.toggle("show");
        });
        document.addEventListener("click", function (event) {
            if (!profileButton.contains(event.target) && !profileBox.contains(event.target)) {
                profileBox.classList.remove("show");
            }
        });
    }
});
window.showGlobalToast = function (message, type = "success") {
    const toast = document.createElement("div");
    toast.className = `global-toast ${type}`;
    toast.innerText = message;
    document.body.appendChild(toast);
    setTimeout(() => {
        toast.classList.add("show");
    }, 10);
    setTimeout(() => {
        toast.classList.remove("show");
        setTimeout(() => document.body.removeChild(toast), 300);
    }, 2500);
};
const menuModel = {
    el: '#menu',
    data() {
        const links = [
            { t: 'Home', l: '/', i: '/images/sidebar/dashboard.svg' },

            { t: 'Monitor', section: true },
            { t: 'Meters', l: '/meters', i: '/images/sidebar/meter.svg', s: 'Monitor' },
            { t: 'Gateway', l: '/gateway', i: '/images/sidebar/gateway.svg', s: 'Monitor' },
            { t: 'Tickets', l: '/tickets', i: '/images/sidebar/tickets.svg', s: 'Monitor' },
            { t: 'Recent', l: '/gateway/recent', i: '/images/sidebar/recent.svg', s: 'Monitor' },
            { t: 'Query', l: '/meters/query', i: '/images/sidebar/activity.svg', s: 'Monitor' },

            { t: 'Manage', section: true },
            { t: 'Customers', l: '/customer', i: '/images/sidebar/customer.svg', s: 'Manage' },
            { t: 'Gateway', l: '/gateway/manage', i: '/images/sidebar/gt-manage.svg', s: 'Manage' },
            { t: 'Sim', l: '/sim', i: '/images/sidebar/sim.svg', s: 'Manage' },
            { t: 'Settings', l: '/settings', i: '/images/sidebar/settings.svg', s: 'Manage' },
            { t: 'Access', l: '/access', i: '/images/sidebar/access.svg', s: 'Manage' },
            { t: 'Correction', l: '/correction', i: '/images/sidebar/set-average.svg', s: 'Manage' },

            { t: 'Projects', section: true },
            { t: 'Production', l: '/projectstatus', i: '/images/sidebar/production.svg', s: 'Projects' },
            { t: 'Installation', l: '/projectstatus/installation', i: '/images/sidebar/install.svg', s: 'Projects' },
            { t: 'Life Cycle', l: '/projectstatus/history', i: '/images/sidebar/lifecycle.svg', s: 'Projects' },
            { t: 'Field Support', l: '/field-support', i: '/images/sidebar/field-support.png', s: 'Projects' },
            { t: 'Wish List', l: '/wishlist', i: '/images/sidebar/wishlist.svg', s: 'Projects' },
        ];

        const activeSectionName = links.find(l => l.l && l.s && window.location.pathname.replaceAll('/', '') === l.l.replaceAll('/', ''))?.s;

        const collapsedSections = {
            'Manage': true,
            'Projects': true,
            'Monitor': true,
        };
        if (activeSectionName) {
            collapsedSections[activeSectionName] = false;
        }
        return {
            collapsedSections,
            links,
        };
    },
    methods: {
        activeLink(l) {
            return window.location.pathname.replaceAll('/', '') === l.replaceAll('/', '');
        },
        toggleSection(name) {
            const isCurrentlyCollapsed = this.collapsedSections[name];
            Object.keys(this.collapsedSections).forEach(key => {
                this.collapsedSections[key] = true;
            });
            if (isCurrentlyCollapsed) {
                this.collapsedSections[name] = false;
            }
        },
        isSectionCollapsed(name) {
            return this.collapsedSections[name];
        },
        hasActiveChild(sectionName) {
            return this.links
                .filter(l => l.s === sectionName && l.l)
                .some(l => this.activeLink(l.l));
        }
    },
};
var appMenu = Vue.createApp(menuModel);
var vmMenu = appMenu.mount("#sidemenu");

const dateOpt = { day: "numeric", month: "short", year: "numeric" };

window.api = {
    sim: '/api/sim',
    gateway: {
        aged: '/api/gateway/aged',
        counts: '/api/gateway/aged/counts',
        deadmeter: '/api/gateway/dead-meters',
        withred: '/api/gateway/with-red',
        deadchannel: '/api/gateway/dead-channels',
        details(p) { return `/api/gateway/${p[0]}`; },
        detailsred(p) { return `/api/gateway/${p[0]}/red`; },
        loraDevices(p) { return `/api/gateway/${p[0]}/lora-devices`; },
        status(p) { return `/api/gateway/${p[0]}/status`; },
        mapping(p) { return `/api/gateway/${p[0]}/mapping`; },
        community(p) { return `/api/gateway/community/${p[0]}`; },
        allgateways: '/api/gateway/allgateways',
        unassigned: '/api/gateway/unassigned',
        updatecstgwt: '/api/gateway/updatecstgwt',
        create(p) { return `/api/gateway/create/${p[0]}`; },
        update(p) { return `/api/gateway/update/${p[0]}`; },
        newcreate: '/api/gateway/new/create',
        suspend(p) { return `/api/gateway/${p[0]}/suspend`; },
        activate(p) { return `/api/gateway/${p[0]}/activate`; },
        master(p) { return `/api/gateway/master/${p[0]}`; },
        activeCount: '/api/gateway/active/count',
        search: (q) => `/api/gateway/search?q=${encodeURIComponent(q)}`,
    },
    meter: {
        import: '/api/meter/import',
        importCheck: '/api/meter/import/check',
        gsmCreate: '/api/meter/gsm/create',
        demoCreate: '/api/meter/demo/create',
        meters(p) { return `/api/meter/${p[0]}/meters`; },
        updateMeter(p) { return `/api/meter/${p[0]}/meters/${p[1]}`; },
        deleteMeter(p) { return `/api/meter/${p[0]}/meters/${p[1]}/${p[2]}`; },
        gsmCount: (p) => `/api/meter/gsm/${p[0]}/count`,
        gsmList: (p) => `/api/meter/gsm/${p[0]}`,
        updateGsmMeter: (p) => `/api/meter/gsm/${p[0]}/${p[1]}`,
        rekeyGsmMeter: (p) => `/api/meter/gsm/${p[0]}/${p[1]}/rekey`,
        deleteAllMeters: (p) => `/api/meter/${p[0]}/meters`,
    },
    customer: {
        all: '/api/customer',
        units(p) { return `/api/meter/${p[0]}/units`; },
        meters(p) { return `/api/meter/unit/${p[0]}/meters`; },
        details(code) { return `/api/customer/${code}`; },
        create: '/api/customer/create',
        update: '/api/customer/update',
        remove(code) { return `/api/customer/${code}`; },
    },
    ticket: {
        counts: '/api/tickets/counts',
        open: '/api/tickets'
    },
    usage: {
        query(p) { return `/api/usage/query/${p[0]}/${p[1]}/${p[2]}/${p[3] ?? ''}`; },
        raw(p) { return `/api/usage/raw/${p[0]}/${p[1]}`; },
        meter(p) { return `/api/usage/meter/${p[0]}`; },
        daily(p) { return `/api/usage/unit/${p[0]}/daily/${p[1]}`; },
        unusualMeters: (date) => `/api/usage/unusual/${date}`,
        meterReading(meterId, timestamp) { return `/api/usage/meter/${meterId}/${timestamp}`; },
        recalculate(day, line) { return `/api/usage/recalculate/${day}/${line}`; },
        hourlyMeter: (unit, date) => `/api/usage/unit/${unit}/hourly/${date}`,
        dailyMeter: (unit, month) => `/api/usage/unit/${unit}/daily-meter/${month}`,
        rawByImei: (p) => `/api/usage/raw/imei/${p[0]}/${p[1]}`,
        meterByImei: (p) => `/api/usage/meter/imei/${p[0]}`,
        correction: '/api/usage/correction',
        meterSearch: (q) => `/api/usage/meters/search?q=${encodeURIComponent(q)}`,
        recentByGateway: (mac) => `/api/usage/recent/gateway/${mac}`,
        monitored: (weekStart) => `/api/usage/monitored/${weekStart}`,
        lineAvgRecalculate: '/api/usage/correction/recalculate',
        today: '/api/usage/today',
        trend: (days) => `/api/usage/trend/${days}`,
        previousDay: '/api/usage/previousday',
        statisticsRange: (from, to) => `/api/usage/statistics/${from}/${to}`,
        archiveByImei: (imei) => `/api/usage/archive/${imei}`,
    },
    user: {
        access(id) { return `/api/user/access/${id}`; },
        accessAll(comId) { return `/api/user/access/${comId}/all`; },
        user(p) { return `/api/user/${p[0]}`; },
        saveAccess: '/api/user/access',
        add: '/api/user/add',
        all: '/api/user',
        settings: '/api/user/settings',
    },
    alerts: {
        forCustomer(cust) { return `/api/log/alert/${cust}`; },
        bulk(codes) { return `/api/log/alert/bulk?codes=${codes}`; },
    },
    production: {
        init: '/api/production/init',
        updateStep: '/api/production/update-step',
        completeDC: '/api/production/complete-dc',
        completeDispatch: '/api/production/complete-dispatch',
        deleteMapped: '/api/production/delete-mapped',
        productionStatus: (args) => `/api/production/status/${args[0]}/${args[1]}`,
        pushProduction: '/api/production/push',
    },
    installation: {
        updateStep: '/api/production/update-arrival',
        archive: '/api/production/archive'
    },
    visit: {
        today: '/api/visit/today',
        archive: '/api/visit/archive',
        supportUsers: '/api/visit/supportUsers',
    },
    wishlist: {
        all: '/api/wishlist',
        create: '/api/wishlist/create',
        status(p) { return `/api/wishlist/${encodeURIComponent(p[0])}/status`; },
    },
    get: async function (url, asText) {
        const res = await fetch(url);
        if (!res.ok) {
            console.error('API GET request failed:', res.statusText);
            return null;
        }
        return asText ? await res.text() : await res.json();
    },
    post: async function (url, body, asText) {
        const res = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!res.ok) {
            const errText = await res.text();
            throw new Error(errText || res.statusText);
        }
        return asText ? await res.text() : await res.json();
    },
    put: async function (url, body, asText) {
        const res = await fetch(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!res.ok) { console.error('API PUT failed:', res.statusText); return null; }
        return asText ? await res.text() : await res.json();
    },
    delete: async function (url) {
        const res = await fetch(url, { method: 'DELETE' });
        if (!res.ok) { console.error('API DELETE failed:', res.statusText); return null; }
        return true;
    }
};